import React from 'react';
import styled from 'styled-components';
import {
  faMoneyCheckAlt,
  faEuroSign,
  faBan,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import swedish from '../swedish.png';
import english from '../english.png';
import { colors } from '../constants';

const Flag = styled.img`
  max-width: 1.5em;
`;

function ExtraFilterIcon({ type }) {
  switch (type) {
    case 'maksuton':
      return (
        <span className="fa-layers fa-fw">
          <FontAwesomeIcon
            icon={faEuroSign}
            color={colors.primary}
            size="sm"
          />
          <FontAwesomeIcon
            icon={faBan}
            color={colors.primary}
            size="lg"
          />
        </span>
      );

    case 'palveluseteli':
      return (
        <FontAwesomeIcon
          icon={faMoneyCheckAlt}
          color={colors.primary}
        />
      );

    case 'ruotsi':
      return (
        <Flag src={swedish} alt="Palvelua ruotsiksi" />
      );

    case 'englanti':
      return (
        <Flag src={english} alt="Palvelua englanniksi" />
      );

    default:
      break;
  }
}

export default ExtraFilterIcon;
